import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { superAdminGuard } from './core/guards/super-admin.guard';
import { organizationGuard } from './core/guards/organization.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'super-admin',
    loadChildren: () => import('./features/super-admin/super-admin.routes').then(m => m.SUPER_ADMIN_ROUTES),
    canActivate: [authGuard, superAdminGuard]
  },
  {
    path: 'workspace',
    loadChildren: () => import('./features/organization/organization.routes').then(m => m.ORGANIZATION_ROUTES),
    canActivate: [authGuard, organizationGuard]
  },
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'auth/login'
  }
];
